import script from "./alipay-recharge-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./alipay-recharge-dialog.vue?vue&type=script&lang=ts&setup=true"

import "./alipay-recharge-dialog.vue?vue&type=style&index=0&id=b48c8982&lang=stylus&scoped=true"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b48c8982"]])

export default __exports__